import { Client as TwilioSyncClient } from "twilio-sync";
import { MessageCompletionStatus } from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

import { types } from "./definitions";

const useTwilioSyncDocument = <DocumentDataType>({
  onComplete,
  onError,
  onStream,
  onInitialize,
}: types.UseTwilioSyncDocumentArgs<DocumentDataType>): types.UseTwilioSyncDocumentReturn => {
  const handleDocumentSync = async ({
    accessToken,
    syncDocumentSid,
  }: types.UseTwilioSyncDocumentHandlerArgs): Promise<void> => {
    // Instantiate sync client with accessToken from WO API
    const syncClient = new TwilioSyncClient(accessToken);

    // Get corresponding sync document for chat
    const document = await syncClient.document(syncDocumentSid);

    /**
     * Initialization of document sync which will include initial
     * data from document creation
     */
    onInitialize(document.data as DocumentDataType);

    /**
     * Create new Promise to handle document updates
     * - Status error: Error from sync => onError
     * - Status complete: Sync is complete => onComplete
     * - Status inProgress: Sync in progress => onStream
     */
    document.on("updated", (event: { data: { status: string } }) => {
      const { status, ...rest } = event.data;

      switch (status) {
        case MessageCompletionStatus.Error: {
          return onError();
        }

        case MessageCompletionStatus.Complete: {
          return onComplete(rest as DocumentDataType);
        }

        // MessageCompletionStatus.InProgress
        default: {
          return onStream(rest as DocumentDataType);
        }
      }
    });
  };

  return {
    handleDocumentSync,
  };
};

export default useTwilioSyncDocument;
